import {
  invalidateBankQuestionsGlobal,
  invalidateBanksCacheGlobal,
  resetQuestionDataCache,
} from "../hooks/useQuestionDataCache";

export const CLIENT_CACHE_RESET_EVENT = "evalris:client-cache-reset";

/** Cache tag constants for selective invalidation. */
export const CACHE_TAGS = {
  BANKS: "banks",
  BANK_QUESTIONS: "bankQuestions",
  SEARCH_USERS: "search:users",
  SEARCH_ASSESSMENTS: "search:assessments",
  SEARCH_MY_ASSIGNMENTS: "search:myAssignments",
  ALL: "*",
};

/**
 * Listeners of CLIENT_CACHE_RESET_EVENT should treat a missing `detail` (or
 * missing `detail.tags`) as a full reset equivalent to tags: ["*"].
 */
export function invalidateClientCaches(tags, meta = {}) {
  const normalizedTags = Array.isArray(tags) ? tags : [];
  const tagSet = new Set(normalizedTags);

  if (tagSet.has(CACHE_TAGS.ALL)) {
    resetClientCaches();
    return;
  }

  if (tagSet.has(CACHE_TAGS.BANKS)) {
    invalidateBanksCacheGlobal();
  }
  if (tagSet.has(CACHE_TAGS.BANK_QUESTIONS)) {
    invalidateBankQuestionsGlobal(meta.bankId);
  }

  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(CLIENT_CACHE_RESET_EVENT, {
        detail: { tags: normalizedTags, bankId: meta.bankId },
      })
    );
  }
}

export function resetClientCaches() {
  resetQuestionDataCache();
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(CLIENT_CACHE_RESET_EVENT, {
        detail: { tags: [CACHE_TAGS.ALL] },
      })
    );
  }
}
